import React from 'react';
import PropTypes from 'prop-types';
import {
  ActionButtonsRow,
  ButtonsContainer,
  ClearButton,
  ApplyButton,
  ButtonText,
} from '../DateRangeTimePicker.styles';

const DateRangeTimePickerActionButtons = ({ onClear, onApply, children }) => {
  return (
    <ActionButtonsRow>
      {children}
      <ButtonsContainer>
        <ClearButton onClick={onClear}>
          <ButtonText>Clear</ButtonText>
        </ClearButton>
        <ApplyButton onClick={onApply}>
          <ButtonText $isWhite>Apply</ButtonText>
        </ApplyButton>
      </ButtonsContainer>
    </ActionButtonsRow>
  );
};

DateRangeTimePickerActionButtons.propTypes = {
  onClear: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default DateRangeTimePickerActionButtons;
